import { Cirus } from "@/classes/Http";
import { IsDate, IsEmail, IsMobilePhone, IsOptional, IsString, IsUUID, validate, ValidateIf } from "class-validator";
import { Message } from "element-ui";

const errorMessages: any = {
    name: 'لطفا نام مشتری را صحیح وارد کنید',
    description: 'لطفا توضیحات را صحیح وارد کنید',
    mobile: 'لطفا شماره همراه را صحیح وارد کنید',
    email: 'لطفا ایمیل را صحیح وارد کنید',
    birthdate: 'لطفا تاریخ تولد را صحیح وارد کنید',
    avatar_id: 'مشکلی در آپلود تصویر وجود دارد، لطفا دوباره آپلود کنید.',
}

export class CreateCustomerBody {
    constructor (body?: CreateCustomerBody) {
        this.name=body?.name||null;
        this.description=body?.description||null;
        this.mobile=body?.mobile||'';
        this.email=body?.email||null;
        this.birthdate=body?.birthdate||null;
        this.avatar_id=body?.avatar_id||null;
    }
    @IsString()
    @IsOptional()
    name: string;

    @IsString()
    @IsOptional()
    description: string;

    @ValidateIf(o => !o.email || o.mobile)
    @IsMobilePhone('fa-IR')
    mobile: string;

    @ValidateIf(o => !o.mobile || o.email)
    @IsEmail()
    email: string;

    @IsDate()
    @IsOptional()
    birthdate?: Date;

    @IsUUID()
    @IsOptional()
    avatar_id: string;
}

export async function createCustomer(instance_id: number, params: CreateCustomerBody) {
    params = new CreateCustomerBody(params);    
    const errors = await validate(params);
    if (errors.length>0)  {
        Message.error(errorMessages[errors[0].property])
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    const path = `/instance/${instance_id}/customer`;
    return Cirus.post(path, params);
}